import React from "react";
import pluralize from "pluralize";
import { bool, number, shape, string } from "prop-types";

import NetEffectiveRentTooltip from "../NetEffectiveRentTooltip";
import * as S from "./styled";

const RentalPricesAndTerms = ({ isSRP, rentalData }) => {
  const tooltipContentPosition = isSRP ? "top" : "bottom";

  return (
    <S.DetailsInfoContainer>
      <S.DetailCell hasRightBorder hasRightPadding>
        <S.DetailText hasRightMargin>
          {rentalData.netEffectivePrice} Net
          {window.innerWidth <= 450 && <br />} Effective Rent
        </S.DetailText>
        <NetEffectiveRentTooltip contentPosition={tooltipContentPosition} />
      </S.DetailCell>
      <S.DetailCell hasLeftPadding hasRightBorder hasRightPadding>
        <S.DetailText>
          {`${pluralize("Month", Number(rentalData.freeMonths), true)} Free`}
        </S.DetailText>
      </S.DetailCell>
      <S.DetailCell hasLeftPadding>
        <S.DetailText>{Number(rentalData.leaseTerm)}-Month Lease</S.DetailText>
      </S.DetailCell>
    </S.DetailsInfoContainer>
  );
};

RentalPricesAndTerms.propTypes = {
  isSRP: bool,
  rentalData: shape({
    netEffectivePrice: string,
    freeMonths: number,
    leaseTerm: number
  }).isRequired
};

RentalPricesAndTerms.defaultProps = {
  isSRP: false
};

export default RentalPricesAndTerms;
